import React, { Component } from 'react';
import { Button } from 'antd';

import {
    obtenirConsentimentLocalStorage,
    acceptarConsentimentLocalStorage
} from '../../commons/gestioConsentimentLocalStorage';

class ConsentimentLocalStorage extends Component {
    render() {
        const consentimentLocalStorageAcceptat = obtenirConsentimentLocalStorage();
        if (consentimentLocalStorageAcceptat) return null;

        return (
            <div className='consentiment-localstorage'>
                <p className='consentiment-localstorage-missatge'>
                    Aquest lloc web utilitza sistemes d'emmagatzematge de dades al teu navegador.
                    Si continues navegant, considerem que n'acceptes l'ús.
                </p>
                <span className='consentiment-localstorage-acceptar'>
                    <Button
                        type='primary'
                        onClick={
                            () => {
                                acceptarConsentimentLocalStorage();
                                this.forceUpdate();
                            }
                        }>
                        D'acord
                    </Button>
                </span>
            </div>
        );
    }
}

export default ConsentimentLocalStorage;



// WEBPACK FOOTER //
// ./src/components/peu/consentimentLocalStorage.js